var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
export var StyledSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 15px;\n  border-right: 2px solid ", ";\n\n  &:last-child {\n    border: none;\n  }\n"], ["\n  padding: 0 15px;\n  border-right: 2px solid ", ";\n\n  &:last-child {\n    border: none;\n  }\n"])), greys.light);
var templateObject_1;
